import { getHotelNewsCategory, getHotelNewsList } from 'actions/news';
import { getBanner } from 'actions/banner';
import { getPopups } from 'actions/popup';
import { getHotelMeta } from 'actions/hotel';

import NewsRoute from './News';

export default store => ({
	path: 'promotions',
	indexRoute: {
		getComponent: (nextState, cb) =>
			require.ensure(
				[],
				require => {
					const component = require('./Home').default;
					cb(null, component);
				},
				'HotelNewsHome',
			),
		onEnter: ({
			params: { lang, hotel },
			location: {
				query: { category, page },
			},
		}) => {
			store.dispatch(getHotelNewsCategory(lang, hotel));
			store.dispatch(getHotelNewsList(lang, hotel, { category, page }));
			store.dispatch(getBanner(lang, hotel, 'news'));
			store.dispatch(getPopups(lang, hotel));
			store.dispatch(getHotelMeta(lang, hotel, 'promotions'));
		},
		onChange: (
			_,
			{
				params: { lang, hotel },
				location: {
					query: { category, page },
				},
			},
		) => {
			store.dispatch(getHotelNewsList(lang, hotel, { category, page }));
		},
	},
	childRoutes: [NewsRoute(store)],
});



// WEBPACK FOOTER //
// ./src/routes/Hotel/News/index.js